import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import agent from './locales/english/agent.json';
import auth from './locales/english/auth.json';
import apps from './locales/english/apps.json';
import common from './locales/english/common.json';
import drafts from './locales/english/drafts.json';
import inviteUser from './locales/english/invite-user.json';
import navigation from './locales/english/navigation.json';
import onboarding from './locales/english/onboarding.json';
import organization from './locales/english/organization.json';
import automation from './locales/english/automation.json';
import automationInputs from './locales/english/automation-inputs.json';
import guidance from './locales/english/guidance.json';
import resourcesTranslations from './locales/english/resources.json';
import settings from './locales/english/settings.json';
import theme from './locales/english/theme.json';
import workspace from './locales/english/workspace.json';
import automations from './locales/english/automations.json';
import userProfile from './locales/english/user-profile.json';
import outputs from './locales/english/outputs.json';
import fileRenderer from './locales/english/file-renderer.json';
import chat from './locales/english/chat.json';
import remoteConnections from './locales/english/remote-connections.json';

const resources = {
  en: {
    agent,
    auth,
    apps,
    common,
    drafts,
    'invite-user': inviteUser,
    navigation,
    onboarding,
    organization,
    automation,
    'automation-inputs': automationInputs,
    guidance,
    resources: resourcesTranslations,
    settings,
    theme,
    workspace,
    automations,
    'user-profile': userProfile,
    outputs,
    'file-renderer': fileRenderer,
    chat,
    'remote-connections': remoteConnections,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: import.meta.env.DEV && !import.meta.env.VITEST,
    defaultNS: 'common',
    // Only load namespaces that are actively used in the codebase
    // This improves performance by not loading unused translation files
    ns: [
      'agent',
      'automations',
      'apps',
      'common',
      'drafts',
      'guidance',
      'navigation',
      'onboarding',
      'organization',
      'automation',
      'automation-inputs',
      'resources',
      'settings',
      'theme',
      'workspace',
      'user-profile',
      'outputs',
      'file-renderer',
      'chat',
      'remote-connections',
    ],

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    // Enable TypeScript support
    returnNull: false,
    returnEmptyString: false,
    returnObjects: false,
  });

export default i18n;
export * from './utils';
